import { useGladlyChat } from '../../hooks/useGladlyChat';

/**
 * @name GladlyChatLoader
 * @description React component that loads the Gladly chat hook to initialize and sync chat settings.
 * It does not render any UI and is intended to be mounted once globally.
 * @type {public}
 * @args {void}
 * @returns {null}
 */
export default function GladlyChatLoader() {
  useGladlyChat();
  return null;
}
